import React from 'react';
import { BtwText } from '../BtwText';
export function TextLogo({ fontSize = 'xl' }) {
    return (React.createElement(BtwText, { className: "font-extrabold transition-all ease-in-out hover:-translate-y-px hover:text-gray-800", size: fontSize, variant: "primary" }, "Ballpark"));
}
